"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endStream = exports.stopAudioStream = exports.restartAudioStream = exports.stopVideoStream = exports.restartVideoStream = void 0;
const restartVideoStream = (stream) => {
    console.log('RESTART LOCAL STREAM');
    const vidTracks = stream.getVideoTracks();
    vidTracks.forEach((track) => (track.enabled = true));
};
exports.restartVideoStream = restartVideoStream;
const stopVideoStream = (stream) => {
    console.log('STOP LOCAL STREAM');
    const vidTracks = stream.getVideoTracks();
    vidTracks.forEach((track) => (track.enabled = false));
};
exports.stopVideoStream = stopVideoStream;
const restartAudioStream = (stream) => {
    console.log('RESTART AUDIO');
    const audTracks = stream.getAudioTracks();
    audTracks.forEach((track) => (track.enabled = true));
};
exports.restartAudioStream = restartAudioStream;
const stopAudioStream = (stream) => {
    console.log('STOP AUDIO');
    const audTracks = stream.getAudioTracks();
    audTracks.forEach((track) => (track.enabled = false));
};
exports.stopAudioStream = stopAudioStream;
const endStream = (stream) => {
    console.log("END STREAM");
    stream.getTracks().forEach((track) => track.stop());
};
exports.endStream = endStream;
//# sourceMappingURL=mediaToggle.js.map